import { useEffect, useState } from 'react';
import { localDrafts } from './localDrafts';

export function useLocalDraft(actor, kind, id) {
  const [, render] = useState(0);
  useEffect(() => localDrafts.subscribe(() => render(value => value + 1)), []);
  return { record: localDrafts.get(actor, kind, id), ready: localDrafts.isReady(actor), open: localDrafts.isOpen(id) };
}
